import gql from 'graphql-tag';
import {surveyOpportunityFragment} from './fragments';

export const surveyOpportunities = gql`
  query surveyOpportunities($where: SurveyOpportunityWhereInput, $orderBy: SurveyOpportunityOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    surveyOpportunities(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) ${surveyOpportunityFragment}
  }
`;
